module.exports = __webpack_public_path__ + "static/media/noRole.286f743e.png";